import { callApi } from './api';

export const updateSupportPlanStatus = async (supportPlanID: number, supportPlanStatus: string) => {
  const { status, result } = await callApi<boolean>(
    `support-plans/${supportPlanID}`,
    'PATCH',
    undefined,
    { status: supportPlanStatus },
    undefined,
    undefined,
    true
  );
  return { status, result };
};
